import React, {useEffect,useState} from 'react'
import Loading from '../../../../common/Loading'
import { useParams } from 'react-router-dom'
import clinicService from '../../../../../services/clinic.service'
import {toast} from 'react-toastify'
import LensList from './LensList'
import { useForm } from 'react-hook-form'
const LensTab = () => {
    const [isEditing,setIsEditing] = useState(false)
    const [loading,setLoading] = useState(false)
    const [lensList,setLensList] = useState([])
    const [addNew,setAddNew] = useState(false)

    const {clinicId} = useParams()

    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm()

    useEffect(()=>{
        //load contact lens from the server
        clinicService.getLens(clinicId)
        .then(res=>{
            setLensList(res.data)
        })
        .catch(err=>{
           
            toast.error("Error while fetching Lens",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
    },[])

    const updateList = (lens)=>{
        const updatedList = lensList.map(item=>{
            if(item.id === lens.id){
                return lens
            }
            return item
        })
        setLensList(updatedList)
    }
    const removeItem = (id)=>{
        const updatedList = lensList.filter(item => item.id !== id)
        
        setLensList(updatedList)
    }
    const onSubmit = (data)=>{
        clinicService.addUpdateLens(clinicId,data)
        .then(res=>{
            const newList = [...lensList,res.data]
            setLensList(newList)
            setAddNew(!addNew)
            toast.success("Added Brand Successfully",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
        .catch(err=>{
            toast.error("Error while adding New Brand",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
    }
    return ( 
        <>
             <div className='d-flex justify-content-between'>
                 <h5 className="card-title" style={{color:"#012970"}}> Contact Lens</h5>
                            <div>
                                <button className="btn btn-secondary btn-sm mt-2 me-2" onClick={()=>setAddNew(!addNew)}> <i className="bi bi-plus-circle bi-sm"></i> Add</button>
                                {isEditing ?
                                <button className="btn btn-secondary btn-sm mt-2"  onClick={()=>setIsEditing(false)}>  
                                    <i className="bi bi-x-square bi-sm"></i> Cancel
                                </button>
                                :
                                <button className="btn btn-secondary btn-sm mt-2" onClick={()=>setIsEditing(true)}>  
                                <i className="bi bi-pencil-square bi-sm"></i> Edit
                            </button>
                                }
                            </div>
             </div>
             <div className='row'>
                 {addNew?<>
                    <form className="row" onSubmit= {handleSubmit(onSubmit)}>
                <div className="col-4">
                <select className='form-select form-select-sm me-2' {...register("status")}>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                </select>
                </div>
                <div className="col-4">
                <input className='form-control form-control-sm' {...register("brandName")} type="text"/>
                </div>
                <div className="col-4">
                    <button type="submit" className="btn btn-sm btn-primary">Add New</button>
                </div>
               

            </form>
                 </>:""}
             {loading ? <Loading/> :
                <>
                {lensList.length === 0 ? <p className='text-center'>No Lens Brand Found. Please Add.</p>:""}
                 <ul className='list-group list-group-flush'>
                    {lensList.map((lens)=>(
                        
                            <LensList key={lens.id} lens={lens} updateList={updateList} removeItem={removeItem} />
                       
                    ))}
            </ul>
               </>
            }
          
           
             </div>
        </>
     );
}
 
export default LensTab;